import { SearchableDropdown } from './SearchableDropdown';

interface TourTypeDropdownProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function TourTypeDropdown({
  value,
  onChange,
  placeholder = 'Select Tour Type',
  className,
}: TourTypeDropdownProps) {
  return (
    <SearchableDropdown
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search tour types..."
      className={className}
      endpoint="tour-types"
      emptyText="No tour types found."
    />
  );
}
